import { render, staticRenderFns } from "./TenantResourceModal.vue?vue&type=template&id=0353ab8a"
import script from "./TenantResourceModal.vue?vue&type=script&lang=js"
export * from "./TenantResourceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports